<template>
  <div class="i-select-group">
    <Select :modelValue="modelValue" :filterable="filterable" :placeholder="placeholder" :disabled="disabled" :clearable="clearable" :multiple="multiple" :max-tag-count="maxTagCount" :loading="loading" label-in-value @on-change="valueChange" @on-clear="valueClear">
      <!-- <OptionGroup :label="d.name" v-if="preCode" v-for="d in tree">
        <Option
          v-for="option in d.children"
          :key="option.code"
          :value="option.code"
        >{{ option.name }}</Option>
      </OptionGroup>
      <Option
        v-else
        v-for="option in tree"
        :key="option.code"
        :value="option.code"
      >{{ option.name }}</Option> -->
      <dict-option :tree="tree" />
    </Select>
    <div class="i-select-append">
      <Button :title="isAuth(['sys:dictionary:modify']) ? '点击编辑' : '无此权限'" @click="onEdit" icon="ios-create" :disabled="!isAuth(['sys:dictionary:modify'])"></Button>
    </div>
    <dict-edit-modal v-if="isAuth(['sys:dictionary:modify'])" v-model="showEdit" :pid="pid" :pCode="parentDict ? parentDict.code : 'OPTION_PCODE'"></dict-edit-modal>
  </div>
</template>
<script>
import { arrayToTree } from '@/utils'
import DictEditModal from './editModal'
import DictOption from './DictOption'
export default {
  name: 'DictSelect',
  components: {
    DictOption,
    DictEditModal
  },
  props: {
    modelValue: {
      type: [Array, String],
      default: ''
    },
    pid: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: false
    },
    maxTagCount: {
      type: Number,
      default: 1
    },
    placeholder: {
      type: String,
      default: () => {
        return "输入关键词进行检索，然后在列表中选择"
      }
    }
  },
  data() {
    return {
      model: "",
      showEdit: false,
      loading: false
    }
  },
  computed: {
    parentDict() {
      return this.$store.state.app.dictionaryList.find(d => d.id === this.pid)
    },
    tree() {
      if (this.parentDict) {
        return arrayToTree(this.$store.state.app.dictionaryList.filter(
          (d) => d.id != this.pid && d.code.startsWith(this.parentDict.code) && d.status == 9
        ))
      } else {
        return []
      }
    },
    options() {
      if (this.parentDict) {
        return this.$store.state.app.dictionaryList.filter(
          (d) => d.id != this.pid && d.code.startsWith(this.parentDict.code) && d.status == 9
        )
      } else {
        return []
      }
    }
  },
  methods: {
    init() {
      this.$store.dispatch('FETCH_DICTIONARY_LIST').then(() => {

      })
    },
    onEdit(event) {
      this.showEdit = true
    },
    valueChange(option) {
      if (option) {
        if (this.multiple) {
          this.$emit('update:modelValue', option.map(o => o.value))
          this.$emit('change', option) //.map(o => o.label)
        } else {
          this.$emit('update:modelValue', option.value)
          this.$emit('change', option) // .label
        }
      }
    },
    valueClear() {
      this.$emit('update:modelValue', null)
      this.$emit('change', null)
    }
  },
}
</script>